"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefinablesCount = exports.getDefinables = exports.getDefinable = exports.definables = exports.definableExists = exports.Definable = void 0;
const Definable_1 = require("./Definable");
Object.defineProperty(exports, "Definable", { enumerable: true, get: function () { return Definable_1.Definable; } });
const definableExists_1 = require("./definableExists");
Object.defineProperty(exports, "definableExists", { enumerable: true, get: function () { return definableExists_1.definableExists; } });
const definables_1 = require("./definables");
Object.defineProperty(exports, "definables", { enumerable: true, get: function () { return definables_1.definables; } });
const getDefinable_1 = require("./getDefinable");
Object.defineProperty(exports, "getDefinable", { enumerable: true, get: function () { return getDefinable_1.getDefinable; } });
const getDefinables_1 = require("./getDefinables");
Object.defineProperty(exports, "getDefinables", { enumerable: true, get: function () { return getDefinables_1.getDefinables; } });
const getDefinablesCount_1 = require("./getDefinablesCount");
Object.defineProperty(exports, "getDefinablesCount", { enumerable: true, get: function () { return getDefinablesCount_1.getDefinablesCount; } });
if (typeof window !== "undefined") {
    window.definables = definables_1.definables;
}
